import { omit } from "lodash";
import styled from "styled-components";
import { colours } from "../../../styles/colours";
import { Icon, IconType } from "../../icons";
import { CustomItemProps, IconContainer, Item, Variant } from "./base";

const StyledItem = styled(Item)<{ disabled?: boolean }>`
  color: ${(props) => (props.disabled ? colours.darkGrey : colours.black)};
  background: ${colours.white};
`;

/** Main Variant */
const MainIcon = styled(IconContainer).attrs<
  { icon: IconType },
  React.ComponentProps<typeof IconContainer>
>((props) => ({
  center: true,
  children: <Icon type={props.icon} colour1={colours.white} />,
  ...omit(props, "icon"),
}))`
  background: ${colours.blue};
`;

/** Sub Variant */
const SubIcon = styled(IconContainer).attrs<
  { icon: IconType },
  React.ComponentProps<typeof IconContainer>
>((props) => ({
  center: true,
  children: <Icon type={props.icon} colour1={colours.primaryBlue} />,
  ...omit(props, "icon"),
}))``;

/** Sub Variant */
const LeafIcon = styled(IconContainer).attrs<
  { icon: IconType },
  React.ComponentProps<typeof IconContainer>
>((props) => ({
  center: true,
  children: <Icon type={props.icon} colour1={colours.blue} />,
  ...omit(props, "icon"),
}))``;

/** Sub Variant */
const DisabledIcon = styled(IconContainer).attrs<
  { icon: IconType },
  React.ComponentProps<typeof IconContainer>
>((props) => ({
  center: true,
  children: <Icon type={props.icon} colour1={colours.darkGrey} />,
  ...omit(props, "icon"),
}))``;

type WhiteItemProps = CustomItemProps & {
  variant?: Variant;
  disabled?: boolean;
};

export const WhiteItem: React.FunctionComponent<WhiteItemProps> = (props) => {
  const { variant, chevron, icon, disabled } = props;
  const propsToPass = omit(props, "icon", "variant", "disabled");

  if (disabled) {
    return (
      <StyledItem
        disabled={disabled}
        icon={icon && <DisabledIcon icon={icon} />}
        {...propsToPass}
        chevron={undefined}
      />
    );
  }

  if (variant === "main")
    return (
      <StyledItem {...propsToPass} icon={icon && <MainIcon icon={icon} />} />
    );

  return (
    <StyledItem
      {...propsToPass}
      icon={
        icon ? (
          chevron ? (
            <SubIcon icon={icon} />
          ) : (
            <LeafIcon icon={icon} />
          )
        ) : null
      }
    />
  );
};
